import { Flex, List, MenuItem, ListItemText, Popover } from '@fullstory/components';
import { useSelectableList } from '@fullstory/react-hooks';
import { fullstorySelectors, InsightDetail } from '@fullstory/redux';
import { generateRoutePath, METRIC_INSIGHT_ROUTE } from '@fullstory/routes';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

interface InsightsActionListProps {
  insights: InsightDetail[];
  open: boolean;
  setOpen: (open: boolean) => void;
  buttonRef: React.RefObject<HTMLButtonElement>;
  placement: React.ComponentProps<typeof Popover>['placement'];
}

export const InsightsActionList: React.FC<InsightsActionListProps> = ({
  insights,
  open,
  setOpen,
  buttonRef,
  placement,
}) => {
  const orgId = useSelector(fullstorySelectors.getOrgId);
  const { getListItemProps, selectedItemIndex } = useSelectableList(
    insights,
    (maybeInsight, insight) => maybeInsight.insightId === insight.insightId,
    () => {},
    { active: open },
  );

  return (
    <Popover
      data-component="InsightsActionList"
      open={open}
      anchor={buttonRef.current}
      placement={placement}
      onCloseSignal={() => setOpen(false)}
      variant="bordered"
      // fits 5 insights before adding a scroll
      maxHeight={325}
      overflow="auto"
      offset={8}
    >
      <List>
        {insights.map((insight, i) => (
          <MenuItem
            {...getListItemProps(insight)}
            key={insight.insightId}
            highlighted={i === selectedItemIndex}
          >
            <Link
              to={generateRoutePath(METRIC_INSIGHT_ROUTE, {
                orgId,
                id: insight.dxObject?.id ?? '',
                insightId: insight.insightId,
              })}
              style={{ textDecoration: 'none' }}
            >
              <Flex alignItems="flex-start" column>
                <ListItemText
                  text={insight.title}
                  subtext={
                    <FormattedMessage
                      defaultMessage="Generated {date, date,::MMM dd, y}"
                      id="mbfX9q"
                      values={{ date: new Date(insight.createdAt as string) }}
                    />
                  }
                />
              </Flex>
            </Link>
          </MenuItem>
        ))}
      </List>
    </Popover>
  );
};
